// V_PSD_PDP_58 | Clickable Store-Benefit Tabs in Product Hero
(function () {
  'use strict';

  var initialized = false;

  function initPdp58() {
    if (initialized) return;
    if (!document.body.classList.contains('c-pdp58VarA')) return;

    var pillOverlay = document.querySelector('.c-pdp58-pill-overlay');
    if (!pillOverlay) return;

    initialized = true;

    // benefit_tabs_view — fires once when the pill row scrolls into the viewport
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          window.igEvents = window.igEvents || [];
          window.igEvents.push({ event: 'benefit_tabs_view' });
          io.disconnect();
        }
      }, { threshold: 0.5 });
      io.observe(pillOverlay);
    }

    // Pill click interactions
    var pills = document.querySelectorAll('.c-pdp58-pill');
    var detailContents = document.querySelectorAll('.c-pdp58-detail-content');
    var detailPanel = document.getElementById('c-pdp58-detail-panel');

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = parseInt(this.dataset.pill, 10);
        var wasActive = this.classList.contains('c-pdp58-pill--active');

        // Fire benefit_pill_click on every tap
        window.igEvents = window.igEvents || [];
        window.igEvents.push({ event: 'benefit_pill_click' });

        // Reset all pills and hide all detail contents
        pills.forEach(function (p) {
          p.classList.remove('c-pdp58-pill--active');
          p.setAttribute('aria-selected', 'false');
        });
        detailContents.forEach(function (c) {
          c.hidden = true;
        });

        if (wasActive) {
          // Tap active pill → deselect and collapse detail copy
          if (detailPanel) detailPanel.classList.remove('c-pdp58-detail-panel--visible');
        } else {
          // Tap inactive pill → activate and show its detail copy
          this.classList.add('c-pdp58-pill--active');
          this.setAttribute('aria-selected', 'true');
          var detail = detailPanel && detailPanel.querySelector('[data-detail="' + idx + '"]');
          if (detail) detail.hidden = false;
          if (detailPanel) detailPanel.classList.add('c-pdp58-detail-panel--visible');
        }
      });
    });
  }

  function tryInit() {
    if (!initialized) initPdp58();
  }

  // Watch for body class being applied by handleExperiments()
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () {
      if (document.body.classList.contains('c-pdp58VarA')) {
        tryInit();
        mo.disconnect();
      }
    });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  // Fallback hooks (handles edge cases where class is set before observer starts)
  document.addEventListener('DOMContentLoaded', tryInit);
  window.addEventListener('ig:ready', function () {
    setTimeout(tryInit, 0);
  });
})();
